// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Width */
    --ds-border-width: 1px;
    --ds-border-width-double: 2px;
    --ds-border-width-focus: var(--ds-05x);
    /* Colors -- Might not be used anywhere as this would force us to use the same borders everywhere,
    Might need more discussion with design team as each component uses different border colors */
    --ds-border-color: var(--ds-color-grey-70);
    --ds-border-color-focus: var(--ds-color-grey-40);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
